import { Component, ErrorInfo, ReactNode } from 'react'

interface Props { children: ReactNode }
interface State { hasError: boolean; error?: Error; errorInfo?: ErrorInfo }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('App crashed:', error, errorInfo)
    this.setState({ error, errorInfo })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, fontFamily: 'monospace', background: '#1a1a1a', color: '#ff6b6b', minHeight: '100vh' }}>
          <h1 style={{ color: '#ff6b6b' }}>WrenchLab Web — Startup Error</h1>
          <h2>{this.state.error?.message}</h2>
          <pre style={{ whiteSpace: 'pre-wrap', color: '#ffa07a' }}>
            {this.state.error?.stack}
          </pre>
          <h3 style={{ color: '#ffd700' }}>Component Stack:</h3>
          <pre style={{ whiteSpace: 'pre-wrap', color: '#98fb98' }}>
            {this.state.errorInfo?.componentStack}
          </pre>
          <h3 style={{ color: '#87ceeb' }}>Environment:</h3>
          <pre style={{ color: '#87ceeb' }}>
{`VITE_API_BASE_URL: ${import.meta.env.VITE_API_BASE_URL || 'NOT SET'}
VITE_CLIENT_TYPE: ${import.meta.env.VITE_CLIENT_TYPE || 'NOT SET'}`}
          </pre>
        </div>
      )
    }
    return this.props.children
  }
}
